define([
    "jquery",
    "underscore",
	"backbone",
	"google_analytics",
    "facebook_pixel"
], function($, _, Backbone, GoogleAnalytics, FacebookPixel) {

    return Backbone.View.extend({
        el: '#content_layout',

        events:{
			'click .print_btn': 'print'
        },

        initialize: function(){
            if(window.pay_method === 'domestic')
            {
                if(window.lang === 'vi_VN')
                {
                    GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_domestic_success_vn);
                }
                else if(window.lang === 'th_TH')
                {
                    GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_domestic_success_th);
                }
            }
            else if(window.pay_method === 'bank_transfer')
            {
                if(window.lang === 'vi_VN')
                {
                    GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.bank_transfer_success_vn);
                }
            }
            else if(window.pay_method === 'mobile')
            {
                if(window.lang === 'th_TH')
                {
                    GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.mobile_success_th);
                }
            }

            if(window.amount_usd)
            {
                const facebookParams = {currency: 'USD', value: window.amount_usd};
                FacebookPixel.sendCustomEvent(FacebookPixel.facebookEventNames.deposit_success, facebookParams);
            }
		},
    });
});
